import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CAROUSEL_FOOTNOTE, CAROUSEL_SUB, CAROUSEL_TITLE, ebookPages } from '../data/sushiContent';
const EASE = [0.23, 1, 0.32, 1] as const;
export function EbookCarouselSection() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const go = (next: number) => {
    const total = ebookPages.length;
    const target = (next + total) % total;
    setDirection(target > index || index === total - 1 && target === 0 ? 1 : -1);
    setIndex(target);
  };
  const current = ebookPages[index];
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="carousel-title" data-id="element-70" data-mp="3bawedw2uchh6">
      <div className="mx-auto max-w-6xl px-5" data-id="element-71" data-mp="2ukrhrs4vbeh">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-72" data-mp="7m2rodmc17ye">
          Adentro del ebook
        </p>
        <h2 id="carousel-title" className="mt-3 text-center font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-73" data-mp="2ypwrlr0t9ary">
          {CAROUSEL_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-[14px] leading-snug text-body sm:text-[15px]" data-id="element-74" data-mp="37igl6d28wp5x">
          {CAROUSEL_SUB}
        </p>

        <div className="mt-9 flex items-center justify-center gap-3 sm:gap-6" data-id="element-75" data-mp="3hetmnx4187b8">
          <button type="button" onClick={() => go(index - 1)} className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out hover:bg-champagne hover:text-charcoal-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne sm:flex" data-id="element-76" data-mp="3cg8kvt94tfko">
            <ChevronLeftIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-77" data-mp="1s16pmcjhpy0q" />
            <span className="sr-only" data-id="element-78" data-mp="3r5ojej1hwbiu">Página anterior</span>
          </button>

          <div className="relative w-full max-w-[20rem] overflow-hidden border border-charcoal-600 bg-charcoal-900 sm:max-w-[23rem]" data-id="element-79" data-mp="3w49nwuns5hd3">
            <div className="aspect-[359/636] w-full" data-id="element-80" data-mp="4wx3m6rlonsy">
              <AnimatePresence initial={false} mode="popLayout" custom={direction} data-id="element-81" data-mp="50b6dg46ez0x">
                <motion.img key={current.image} src={current.image} alt={`Página del ebook: ${current.caption}`} custom={direction} initial={{
                opacity: 0,
                x: direction * 28
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -28
              }} transition={{
                duration: 0.25,
                ease: EASE
              }} className="absolute inset-0 h-full w-full object-cover" width={359} height={636} data-id="element-82" data-mp="9uyl4n9dof2b" />
              </AnimatePresence>
            </div>
          </div>

          <button type="button" onClick={() => go(index + 1)} className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out hover:bg-champagne hover:text-charcoal-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne sm:flex" data-id="element-83" data-mp="2m6i7agwuhqff">
            <ChevronRightIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-84" data-mp="35tfwuugoiupe" />
            <span className="sr-only" data-id="element-85" data-mp="30wh7ep7ynbxj">Página siguiente</span>
          </button>
        </div>

        <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-champagne" aria-live="polite" data-id="element-86" data-mp="2w34s55p68hhg">
          {current.caption}
          <span className="ml-3 font-medium tracking-[0.14em] text-muted" data-id="element-87" data-mp="3ol0g35ux9qq5">
            {index + 1} / {ebookPages.length}
          </span>
        </p>

        <div className="mt-4 flex items-center justify-center gap-3 sm:hidden" data-id="element-88" data-mp="3js77u808w09b">
          <button type="button" onClick={() => go(index - 1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out active:bg-champagne active:text-charcoal-950" data-id="element-89" data-mp="34apdzrc0ampv">
            <ChevronLeftIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-90" data-mp="2zd5yyp7hi5wv" />
            <span className="sr-only" data-id="element-91" data-mp="3n30cl8zmnyi6">Página anterior</span>
          </button>
          <button type="button" onClick={() => go(index + 1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out active:bg-champagne active:text-charcoal-950" data-id="element-92" data-mp="3s0jrmb45gfb6">
            <ChevronRightIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-93" data-mp="9v6qom6gj1x5" />
            <span className="sr-only" data-id="element-94" data-mp="enqfkfalhjh9">Página siguiente</span>
          </button>
        </div>

        <ul className="no-scrollbar mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-1 sm:justify-center sm:flex-wrap sm:overflow-visible" data-id="element-95" data-mp="1zcals2rlcaww">
          {ebookPages.map((page, i) => <li key={page.image} className="shrink-0 snap-start" data-id="element-96" data-mp="285xetl4ez02e" data-mpi={i}>
              <button type="button" onClick={() => go(i)} aria-current={i === index} className={`block w-[4.5rem] overflow-hidden border transition-[border-color,opacity] duration-150 ease-out sm:w-[5.25rem] ${i === index ? 'border-champagne opacity-100' : 'border-charcoal-600 opacity-55 hover:opacity-100'}`} data-id="element-97" data-mp="2878i7jty65sz">
                <img src={page.image} alt="" className="aspect-[359/636] w-full object-cover" width={359} height={636} loading="lazy" data-id="element-98" data-mp="1ke9x9tt1l1cs" />
                <span className="sr-only" data-id="element-99" data-mp="1ti3pfszngd51">Ver {page.caption}</span>
              </button>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg italic leading-snug text-champagne sm:text-xl" data-id="element-100" data-mp="1yfc59mxbs534">
          {CAROUSEL_FOOTNOTE}
        </p>
      </div>
    </section>;
}